export default String.raw`
<div class="page-padding">
	<section class="contact-container">
		<div class="contact-container__details">
			{% if config.Shop.Name != '' or config.Shop.Address[0] -%}
			<div class="contact-info">
				<div class="contact-info__title">
					<h3>{{ translations.AddressDetails }}</h3>
				</div>
				<div class="contact-info__details">
					<span>{{ config.Shop.Name }}</span>
					<span>
						{{ config.Shop.Address.Street }}
						{{ config.Shop.Address.StreetNo }}
					{% if config.Shop.Address.UnitNo != '' -%}
						/{{ config.Shop.Address.UnitNo }}
					{% endif -%}
					</span>
					<span>{{ config.Shop.Address.ZipCode }} {{ config.Shop.Address.City }}</span>
					{% if config.Shop.Address.Country != '' -%}
					<span>{{ config.Shop.Address.Country }}</span>
					{% endif -%}
				</div>
			</div>
			{% endif -%}
			{% assign bank = config.Currencies[customer.Currency].BankAccount -%}
			{% if config.Shop.TIN != '' or config.Shop.Regon != '' or bank.AccountNumber != '' or config.Shop.Registrant !='' -%}
			<div class="contact-info">
				<div class="contact-info__title">
					<h3>{{ translations.CompanyData }}</h3>
				</div>
				<div class="contact-info__details">
					{% if bank.AccountNumber != '' -%}
					<span>
						{{ translations.Bank }}: {{ bank.Bank }}
					</span>
					<span>{{ translations.BankAccountNumber }}: {{ bank.SWIFT }} {{ bank.AccountNumber }}</span>
					{% endif -%}
					{% if config.Shop.TIN != '' -%}
					<span>{{ translations.TIN }}: {{ config.Shop.TIN }}</span>
					{% endif -%}
					{% if config.Shop.Regon != '' -%}
					<span>{{ translations.REGON }}: {{ config.Shop.Regon }}</span>
					{% endif -%}
					{% if config.Shop.Registrant !='' -%}
					<span>{{ translations.RegistrantInfo }}: {{ config.Shop.Registrant | NewlineToBr }}</span>
					{% endif -%}
				</div>
			</div>
			{% endif -%}
			{% if config.Shop.Contact.PhoneNo != '' or config.Shop.Contact.PhoneNo2 != '' or config.Shop.Contact.Fax != '' or config.Shop.Contact.GSM != '' or config.Shop.Contact.Skype != '' or config.Shop.Contact.Email != '' -%}
				<div class="contact-info">
					<div class="contact-info__title">
						<h3>{{ translations.Contact }}</h3>
					</div>
					<div class="contact-info__details">
						{% if config.Shop.Contact.PhoneNo != '' or config.Shop.Contact.PhoneNo2 != '' or config.Shop.Contact.Fax != '' or config.Shop.Contact.GSM != '' -%}
						<div class="contact-wrapper">
							<svg height="24" width="24" class="contact-info__icon">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#headset-{{settings.iconStyle}}"></use>
							</svg>
							<div class="contact-wrapper__details">
								{% if config.Shop.Contact.PhoneNo != '' -%}
								<span><a href="tel:{{ config.Shop.Contact.PhoneNo }}">{{ config.Shop.Contact.PhoneNo }}</a></span>
								{% endif -%}
								{% if config.Shop.Contact.PhoneNo2 != '' -%}
								<span><a href="tel:{{ config.Shop.Contact.PhoneNo2 }}">{{ config.Shop.Contact.PhoneNo2 }}</a></span>
								{% endif -%}
								{% if config.Shop.Contact.Fax != '' -%}
								<span><a href="tel:{{ config.Shop.Contact.Fax }}">{{ config.Shop.Contact.Fax }}</a></span>
								{% endif -%}
								{% if config.Shop.Contact.GSM != '' -%}
								<span><a href="tel:{{ config.Shop.Contact.GSM }}">{{ config.Shop.Contact.GSM }}</a></span>
								{% endif -%}
							</div>
						</div>
						{% endif -%}
						{% if config.Shop.Contact.Skype != '' -%}
						<div class="contact-wrapper">
							<svg height="24" width="24" class="contact-info__icon">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#skype"></use>
							</svg>
							<div class="contact-wrapper__details">
								<span><a href="tel:{{ config.Shop.Contact.Skype }}">{{ config.Shop.Contact.Skype }}</a></span>
							</div>
						</div>
						{% endif -%}
						{% if config.Shop.Contact.Email != '' -%}
						<div class="contact-wrapper">
							<svg height="24" width="24">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use>
							</svg>
							<div class="contact-wrapper__details">
								<span><a href="mailto:{{ config.Shop.Contact.Email }}">{{ config.Shop.Contact.Email }}</a></span>
							</div>
						</div>
						{% endif -%}
					</div>
				</div>
			{% endif -%}
			{% if config.Shop.Description != '' -%}
			<div class="contact-info additional-info">
				<div class="contact-info__title">
					<h3>{{ translations.AdditionalInfo }}</h3>
				</div>
				<span>{{ config.Shop.Description }}</span>
			</div>
			{% endif -%}
		</div>
		<div class="contact-container__form">
			<div class="contact-container__form__header">
				<h2>{{translations.ContactForm}}</h2>
			</div>
			<div class="form-js" data-success="{{ translations.ContactMessageSent }}">
				<input type="hidden" name="__action" value="Contact/Send" >
				{% if config.Contact.Contacts[0] -%}
				<div class="form__input-wrapper">
					<label for="contactId" class="form__input-info input-info-js">{{ translations.Department }}</label>
					<select id="contactId" name="contactId" class="form__input-value input-value-js" required>
						{% for contact in config.Contact.Contacts -%}
						<option value="{{ contact.Id }}">{{ contact.Name }}</option>
						{% endfor -%}
					</select>
				</div>
				{% endif -%}
				<div class="form__input-wrapper">
					<label for="contactEmail" data-type="email" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.Email }}</label>
					<input class="form__input-value input-value-js onlyInputEventValidation" id="contactEmail" type="email" name="email" value="{{ customer.Email }}" autocomplete="email" maxlength="192" required>  
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
					<div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
				</div>
				<div class="form__input-wrapper">
					<label for="contactPhoneNo" class="form__input-info input-info-js">{{ translations.PhoneNumber }}</label>
					<input id="contactPhoneNo" class="form__input-value input-value-js" type="tel" name="phoneNo" value="{{ customer.Address.PhoneNo }}" maxlength="20" >
				</div>
				<div class="form__input-wrapper">
					<label for="contactSubject" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.Subject }}</label>
					<input id="contactSubject" class="form__input-value input-value-js" type="text" name="subject" maxlength="50" required >
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillSubject }}</div>
				</div>
				<div class="form__input-wrapper">
					{% assign maxLength = 500 -%}
					<label for="content-textarea" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.MessageContent }}</label>
					<div class="scrollable"></div>
					<textarea id="content-textarea" class="form__input-value input-value-js" aria-label="{{ translations.MessageContent }}" maxlength="500" name="message" required></textarea>
					<div class="characters-counter characters-counter-js"></div>
					<div class="characters-length characters-length-js">{{ translations.Com_MaxFieldSize | Format: maxLength }}</div>
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillMessageContent }}</div>
				</div>
				{% if config.Contact.AttachmentsEnabled -%}
				<div class="file-attachements-wrapper">
					<label for="contact-file" class="file add-attachement-label-contact-js" style="margin-top: 20px;"><svg width="24" height="24"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#paperclip-{{settings.iconStyle}}"></use></svg> {{ translations.AddAttachement }} <span>(Max. {{ config.Contact.AttachmentsMaxCount }})</span></label>
					{% capture maxSize -%}{{config.Contact.AttachmentMaxSize}}B{% endcapture -%}
					{% for i in (1..config.Contact.AttachmentsMaxCount) -%}
						{% assign index = forloop.index -%}
						<div class="file custom-input-file-container-js hidden-js">
							<label for="file-{{index}}" class="file">
								<i class="icon-js">
									<svg width="24" height="24" class="svgIcon">
										<use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#paperclip-{{settings.iconStyle}}"></use>
									</svg>
								</i>
								<span class="input-text-js" data-empty="{{ translations.AddAttachement }}">{{ translations.AddAttachement }}</span>
								<input id="file-{{index}}" class="add-attachement-in-complaint-js contact-file-js hidden-js" type="file" name="file" accept="{{ config.Contact.AttachmentExtensions }}" data-file-size="{{ config.Contact.AttachmentMaxSize }}" data-size-exceeded="{{ translations.Com_FileSizeExceeded | Format: maxSize }}" data-invalid-file="{{ translations.Com_InvalidFile | Format: config.Contact.AttachmentExtensions }}" >
							</label>
							<i class="close-button clear-contact-file-input-js hidden-js" accept="{{ config.Contact.AttachmentExtensions }}" data-file-size="{{ config.Contact.AttachmentMaxSize }}" data-size-exceeded="{{ translations.Com_FileSizeExceeded | Format: maxSize }}" data-invalid-file="{{ translations.Com_InvalidFile | Format: config.Contact.AttachmentExtensions }}">
								<svg width="24" height="24" class="svgIcon">
									<use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
								</svg>
							</i>
						</div>
					{% endfor -%}
				</div>
				{% endif -%}
				<ul class="consentsList">
					<li class="consentsList__li">
						<div class="checkBoxes__container">
							<input id="form__checkbox" class="form__input-value-js" type="checkbox" name="copy" value="1" >
							<label role="checkbox" tabindex="0" aria-checked="false" for="form__checkbox">
								<span class="checkBoxes__checkIcon" style="top: -1px;">
									<svg>
										<use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-{{settings.iconStyle}}"></use>
									</svg>
								</span>
								<span class="form__checkbox__sendCopy">{{ translations.SendMeCopy }}</span>
							</label>
						</div>
					</li>
				</ul>
				<div class="required-fields"><span class="required">*</span> {{ translations.RequiredFields }}</div>
				<button aria-label="send-contact-form" class="primary-action-button send-contact-form-js">
					{{ translations.Send }}
				</button>
			</div>
		</div>
		{% if config.Shop.Address.Latitude != 0 and config.Shop.Address.Longitude != 0 and settings.googleMapsKey != '' -%}
		<div class="map-container">
			<div class="map map-js" data-latitude="{{ config.Shop.Address.Latitude }}" data-longitude="{{ config.Shop.Address.Longitude }}" data-address="{{ config.Shop.Address.Street }} {{ config.Shop.Address.StreetNo }} {% if config.Shop.Address.UnitNo != '' -%} / {{ config.Shop.Address.UnitNo }} {% endif -%}" data-shop-name="{{ config.Shop.Name | H }}">
			</div>
		</div>
	{% endif -%}
	</section>
</div>

{% include 'partials/rich-snippets/corporate-contacts.html' -%}
`